import classNames from "classnames";
import PropTypes from "prop-types";

import OrderStatusButton from "@/components/actions/button/OrderStatusBtn";
import { useScrollToRef } from "@/hooks";

export const OrderStatusBar = ({ data, active, clickHandler }) => {
  const { ref: activeButtonRef } = useScrollToRef([active]);

  return (
    <div className={`flex flex-nowrap overflow-x-auto pb-[0.65rem]`}>
      {data.map(({ key, value }) => (
        <OrderStatusButton
          key={key}
          status={{ label: value, value: key }}
          className={classNames({
            "bg-primary font-semibold text-white": active === key,
            "bg-grayDisplay-600 font-medium text-grayDisplay-700":
              active !== key,
          })}
          onClick={({ value }) => clickHandler(value)}
          ref={active === key ? activeButtonRef : null}
        />
      ))}
    </div>
  );
};

OrderStatusBar.propTypes = {
  active: PropTypes.string,
  clickHandler: PropTypes.func,
  data: PropTypes.arrayOf(
    PropTypes.shape({ key: PropTypes.string, value: PropTypes.string })
  ).isRequired,
};
